import InfoCsvExportButton from "../../components/InfoCsvExportButton.js";
import { monthlyMilkCsv } from "../../utils/info-report-csv.js";
import { memo, useState } from "react";
import Spinner from "../../components/Spinner.js";
import SelectOwnerForm from "../../components/forms/OwnerSelect.js";
import { useSnackbar } from "../../utils/index.js";
import { getMonthlyMilkData } from "../../api/index.js";
import MonthlyMilkProductionPdf from "../../components/info-pdfs/MonthlyMilkProduction.js"


const MonthlyMilkingProduction = () => {
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [step, setStep] = useState(1);
    const [milkingData, setMilkingData] = useState([]);

    const { error } = useSnackbar();

    const fetchMilkData = async (selOwner, year, month, monthWording) => {
        setIsLoading(true);
        setSelectedYear(year);
        setSelectedMonth(monthWording);
        const { success: scs, milkData, message } = await getMonthlyMilkData(selOwner, year, month);
        if (scs) {
            setMilkingData(milkData);
            setStep(2);
        } else {
            error(message);
        }
        setIsLoading(false);
    }
    return (
        <>
            <Spinner open={isLoading} />
            {step === 1 && (
                <SelectOwnerForm
                    setSelectedOwner={setSelectedOwner}
                    title={"Μηνιαία Γαλακτοπαραγωγή"}
                    setStep={setStep}
                    method={fetchMilkData}
                    screenCase={"MonthlyMilkingProduction"}
                />
            )}
            {step === 2 && (
                <>
                    <InfoCsvExportButton filename={`miniaia_galaktometrisi_${selectedOwner?.code || "ektrofi"}_${selectedYear}_${selectedMonth}`}
                        getRows={() => monthlyMilkCsv(selectedOwner, selectedYear, selectedMonth, milkingData)} disabled={!milkingData?.length} />
                    <MonthlyMilkProductionPdf
                        selectedOwner={selectedOwner}
                        milkData={milkingData}
                        selectedYear={selectedYear}
                        selectedMonth={selectedMonth}
                    />
                </>
            )}
        </>
    )
}

export default memo(MonthlyMilkingProduction)